export default "__VITE_ASSET__DCJZ$hIS__"